import { createScormApiForLessons } from "@/cmi5/globalapi/createScormApiForLessons";
import { createScormApiForUI } from "@/cmi5/globalapi/createScormApiForUI";
window.COURSE_DATA_API = null;
window.API_1484_11 = null;
// without this scorm 1.2 (translating to 1.3) facade api, the initial 2021 config will not work
window.API = null;
export function createGlobalApi(courseApi) {
    window.API_1484_11 = createScormApiForLessons(courseApi);
    // without this scorm 1.2 (translating to 1.3) facade api, the initial 2021 config will not work
    window.API = createScormApiForUI(courseApi);
}
